import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=b9da172e&scoped=true&"
import script from "./OrderInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoice.vue?vue&type=style&index=0&id=b9da172e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9da172e",
  null
  
)

export default component.exports